import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const withAuth = (ComposedComponent) => {
  const mapStateToProps = (state) => ({
    isAuthenticated: state.profile.auth.isAuthenticated,
    userProfileLoaded: state.profile.user.userProfileLoaded,
    isEulaAccepted: state.profile.user.isEulaAccepted,
    userEmail: state.profile.user.email,
    loginType: state.profile.auth.loginType,
  });

  class AuthenticatedContainer extends Component {
    UNSAFE_componentWillMount() {
      this.checkAuth(this.props);
    }

    UNSAFE_componentWillReceiveProps(props) {
      this.checkAuth(props);
    }

    checkAuth(props) {
      if (!props.isAuthenticated) {
        this.redirectToLogin();
        return;
      }
      if (props.userProfileLoaded &&
          !props.userEmail &&
          ['singlesignon', 'patientkioskuser', 'patientlinkuser'].indexOf(props.loginType.toLowerCase()) < 0) {
        this.props.history.push('/provide-email');
      }
    }

    redirectToLogin() {
      this.props.history.push('/login');
    }

    render() {
      const { isAuthenticated, isEulaAccepted, loginType } = this.props;
      const isKioskOrLinkUser = loginType && (loginType.toLowerCase() === 'patientkioskuser'
        || loginType.toLowerCase() === 'patientlinkuser');

      return (
        <div>
          { isAuthenticated && (isKioskOrLinkUser || isEulaAccepted)
            ? <ComposedComponent {...this.props} />
            : null}
        </div>
      );
    }
  }

  AuthenticatedContainer.propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object,
    isAuthenticated: PropTypes.bool,
    userProfileLoaded: PropTypes.bool,
    isEulaAccepted: PropTypes.bool,
    userEmail: PropTypes.string,
    loginType: PropTypes.string,
  };

  return withRouter(connect(mapStateToProps)(AuthenticatedContainer));
};

export {
  withAuth,
};
